import React, { Component } from 'react';
import { Row } from 'reactstrap';

class FormBuilder extends Component {
  render() {
    let forms;
    switch (this.props.section) {
      case 'PROGRAM':
        forms = this.props.programForm;
        break;
      case 'HARDWARE':
        forms = this.props.hardwareForm;
        break;
      case 'PROJECT':
      default:
        forms = this.props.projectForm;
        break;
    }

    return <Row>{forms}</Row>;
  }
}

export default FormBuilder;



// WEBPACK FOOTER //
// ./src/components/FormBuilder.js